(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dr-pdp-design"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-dr-nutrition]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    if (!target.open) target.querySelector('summary')?.click();
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
    target.querySelector('summary')?.focus({preventScroll:true});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
